<div class="prf-footer-contacts">
  <div class="prf-footer-contacts-item">
    <a [href]="'tel:' + formattedPhone" class="prf-footer-contacts-item-text" (click)="onClickPhoneLink()">{{ originalPhone }}</a>
    <p class="prf-footer-contacts-item-title">{{ title }}</p>
  </div>
</div>
